import React, { memo } from 'react'
import { useFeedbackBox, FeedbackBoxProps } from './useFeedbackBox'
import styles from './FeedbackBox.module.scss'
import Modal from 'components/Modal/Modal'
import Rating from './Rating/Rating'

const FeedbackBox: React.FC<FeedbackBoxProps> = (props: FeedbackBoxProps) => {
  const {
    title,
    rating,
    comment,
    isLoading,
    isSendFeedbackSuccess,
    isError,
    sendFeedbackResponseMessage,
    errorMessage,
    boxBgColor,
    boxTitleColor,
    btnSubmitBgColor,
    btnSubmitTextColor,
    setShowFeedbackBox,
    setRating,
    setComment,
    onSubmit,
  } = useFeedbackBox(props)

  return (
    <form className={styles['feedback-box']} onSubmit={onSubmit}>
      <Modal
        title={title}
        bgColor={boxBgColor}
        titleColor={boxTitleColor}
        btnSubmitBgColor={btnSubmitBgColor}
        btnSubmitTextColor={btnSubmitTextColor}
        btnSubmitLabel='Send'
        isBtnSubmitDisabled={isLoading}
        onClose={() => setShowFeedbackBox(false)}
      >
        <Rating rate={rating} setRate={setRating} />

        <div className={`${styles['form-floating']} mb-3`}>
          <textarea
            className={`form-control ${styles['form-control']}`}
            id='commentInput'
            name='comment'
            value={comment}
            rows={5}
            placeholder='Your Comment (optional)'
            onChange={(e) => setComment(e.target.value)}
            style={{ height: 150 }}
          ></textarea>
          <label htmlFor='commentInput'>Comment (optional)</label>
        </div>

        <div className='my-3'>
          <div
            className={styles.loading}
            style={{ display: isLoading ? 'block' : 'none' }}
          ></div>
          <div
            className={styles['error-message']}
            style={{
              display:
                isSendFeedbackSuccess === false || isError ? 'block' : 'none',
            }}
          >
            {sendFeedbackResponseMessage}
            {errorMessage}
          </div>
          <div
            className={styles['sent-message']}
            style={{
              display: isSendFeedbackSuccess ? 'block' : 'none',
            }}
          >
            {sendFeedbackResponseMessage}
          </div>
        </div>
      </Modal>
    </form>
  )
}

export default memo(FeedbackBox)
